/* eslint-disable better-mutation/no-mutation */

export default function ThrottledAction(minDelayInMs, alwaysDelay) {
    var lastActionTime = 0;
    var timeoutId = null;
    this.execute = function (wrappedAction) {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        var timeNow = Date.now();
        var elapsed = timeNow - lastActionTime;
        if (!alwaysDelay && elapsed > minDelayInMs) {
            wrappedAction();
            lastActionTime = timeNow;
        } else {
            timeoutId = setTimeout(() => {
                wrappedAction();
            }, minDelayInMs);
        }
    };
}
